import { Component } from '@angular/core';
import { DestructorComponent } from '../destructor/destructor.component';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent extends DestructorComponent{

  imageUploaded = false;
  primaryImage:string = '';
  images: any[] = [];

  constructor(private _generalService:GeneralService) {
    super();
  }



  uploadFile(file: any) {

    this.imageUploaded = true;
    this._generalService.uploadFileByContent({ "contentType": file.type }).subscribe(res => {

      console.log('res-->', res)
      const imageUrl = res.data.url;
      let formData = this._generalService.convertKeysToFormdata(res.data.result.fields, file);


      this._generalService.sendFileToS3(res.data.result.url, formData).subscribe(res => {
        this.imageUploaded = false;
        this.primaryImage =`url('${imageUrl}')`
        this.images.push({ imageUrl })
      })

    })
  }
}
